import {ZadSupplier, ZadSupplierWritePayload} from '../../../models/zad'
import {normalizeZadCode} from './categoryHelpers'
import {resolveZadUserMessage, ZadApiError} from './errors'

export const DEFAULT_ZAD_SUPPLIER_COUNTRY = 'Tunisie'

export function preserveZadSupplierString(value: unknown): string {
  if (value == null) return ''
  return String(value)
}

export function displayZadOptional(value: unknown): string {
  const text = preserveZadSupplierString(value).trim()
  return text || '—'
}

export type ZadSupplierFormValues = {
  name: string
  code: string
  taxId: string
  phone: string
  secondaryPhone: string
  email: string
  address: string
  city: string
  country: string
  contactPerson: string
  rib: string
  notes: string
}

export function toZadSupplierFormValues(supplier?: ZadSupplier | null): ZadSupplierFormValues {
  if (!supplier) {
    return {
      name: '',
      code: '',
      taxId: '',
      phone: '',
      secondaryPhone: '',
      email: '',
      address: '',
      city: '',
      country: DEFAULT_ZAD_SUPPLIER_COUNTRY,
      contactPerson: '',
      rib: '',
      notes: '',
    }
  }
  return {
    name: supplier.name || '',
    code: supplier.code || '',
    taxId: preserveZadSupplierString(supplier.taxId),
    phone: preserveZadSupplierString(supplier.phone),
    secondaryPhone: preserveZadSupplierString(supplier.secondaryPhone),
    email: supplier.email || '',
    address: supplier.address || '',
    city: supplier.city || '',
    country: supplier.country || DEFAULT_ZAD_SUPPLIER_COUNTRY,
    contactPerson: supplier.contactPerson || '',
    rib: preserveZadSupplierString(supplier.rib),
    notes: supplier.notes || '',
  }
}

export function validateZadSupplierForm(values: ZadSupplierFormValues): string | null {
  if (!String(values.name || '').trim()) return 'ZAD.COMMON.NAME_REQUIRED'
  if (!String(values.code || '').trim()) return 'ZAD.COMMON.CODE_REQUIRED'
  return null
}

export function toZadSupplierPayload(values: Partial<ZadSupplierFormValues> & {
  name: string
  code: string
}): ZadSupplierWritePayload {
  return {
    name: String(values.name || '').trim(),
    code: normalizeZadCode(values.code),
    taxId: preserveZadSupplierString(values.taxId).trim(),
    phone: preserveZadSupplierString(values.phone).trim(),
    secondaryPhone: preserveZadSupplierString(values.secondaryPhone).trim(),
    email: values.email != null ? String(values.email).trim() : '',
    address: values.address != null ? String(values.address).trim() : '',
    city: values.city != null ? String(values.city).trim() : '',
    country: values.country != null ? String(values.country).trim() : DEFAULT_ZAD_SUPPLIER_COUNTRY,
    contactPerson: values.contactPerson != null ? String(values.contactPerson).trim() : '',
    rib: preserveZadSupplierString(values.rib).trim(),
    notes: values.notes != null ? String(values.notes).trim() : '',
  }
}

export function resolveZadSupplierMessage(err: ZadApiError): {i18nId: string; fallback: string} {
  if (err.errorCode === 'DUPLICATE_CODE') {
    return {
      i18nId: 'ZAD.SUPPLIERS.DUPLICATE_CODE',
      fallback: 'A supplier with this code already exists.',
    }
  }
  return resolveZadUserMessage(err)
}
